import React from 'react';
import LoaderImage from '../../assets/Images/earth-loader.gif';

const Loader = () => {
    return (
        <div className='d-flex align-items-center justify-content-center vw-100 vh-100'>
            <img src={LoaderImage} alt='loader' style={{width: '120px'}} />
        </div>
    );
};

export default Loader;
